import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import Input from '../../ui/Input';
import DocumentacionSelect from '../DocumentacionSelect';
import colors from '../../../theme/colors';

const FiltrosFila3 = ({
  searchContext, isTableNotLoading, phone, idStripe,
  selectedIds, setSelectedIds, formationCenter, formationList, handleFormationCenter,
  deudores, userOU,
  handlePhoneOnChange, handleIdStripeOnChange, handleDeudor,
}) => {
  const hasRestoredSearch = searchContext !== '' && searchContext.newSearch === false;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: '12px' }}>
      <div>
        <label
          htmlFor="centroFormacion"
          style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#6b7280', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.04em' }}
        >
          Centro estudio
        </label>
        {userOU.idCedesca > 0 ? (
          <input type="text" name="centroFormacion" placeholder={userOU.centro} disabled
            style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '0.8rem', backgroundColor: '#f3f4f6', color: '#6b7280', cursor: 'not-allowed', boxSizing: 'border-box' }} />
        ) : (
          <ReactSelect
            options={Array.isArray(formationList) ? formationList : []}
            value={formationCenter || null}
            isMulti
            closeMenuOnSelect={false}
            onChange={handleFormationCenter}
            placeholder="Seleccionar..."
            isDisabled={!isTableNotLoading}
          />
        )}
      </div>
      <Input label="Móvil" type="text" name="movil" id="movil" placeholder="Móvil"
        onChange={handlePhoneOnChange} onInput={handlePhoneOnChange}
        defaultValue={hasRestoredSearch ? phone.data : ''} disabled={!isTableNotLoading}
        error={phone.error ? (phone.error === 'format' ? 'Formato incorrecto' : phone.error) : undefined} />
      <Input label="ID Stripe" type="text" name="idstripe" id="idstripe" placeholder="ID Stripe"
        onChange={handleIdStripeOnChange} onInput={handleIdStripeOnChange}
        defaultValue={idStripe.data} disabled={!isTableNotLoading}
        error={idStripe.error ? 'ID Stripe inválido' : undefined} />
      <div>
        <label
          htmlFor="iddocu"
          style={{ display: 'block', fontSize: '0.75rem', fontWeight: 600, color: '#6b7280', marginBottom: '4px', textTransform: 'uppercase', letterSpacing: '0.04em' }}
        >
          Doc. pendiente
        </label>
        <DocumentacionSelect selectedIdsString={selectedIds} onChangeSelected={setSelectedIds} />
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', paddingBottom: '4px' }}>
        <label style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
          <input type="checkbox" id="deudores" name="deudores" checked={deudores} onChange={handleDeudor}
            style={{ width: '16px', height: '16px', accentColor: colors.primary }} />
          <span style={{ fontSize: '0.8rem', fontWeight: 500, color: '#374151' }}>Deudores</span>
        </label>
      </div>
    </div>
  );
};

FiltrosFila3.propTypes = {
  searchContext: PropTypes.object, isTableNotLoading: PropTypes.bool,
  phone: PropTypes.object, idStripe: PropTypes.object,
  selectedIds: PropTypes.string, setSelectedIds: PropTypes.func,
  formationCenter: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  formationList: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  handleFormationCenter: PropTypes.func,
  deudores: PropTypes.bool, userOU: PropTypes.object,
  handlePhoneOnChange: PropTypes.func, handleIdStripeOnChange: PropTypes.func,
  handleDeudor: PropTypes.func,
};

export default FiltrosFila3;
